import { z } from "zod";
import api from "./api";
import { toast } from "../components/ui/use-toast";

const inputSchema = z.object({
  name: z.string(),
  description: z.string(),
  value: z.string(),
});

export async function editKnowledgeBase(
  itemId: string,
  data: Partial<z.infer<typeof inputSchema>>,
) {
  try {
    const result = inputSchema.safeParse(data);
    if (!result.success) {
      throw new Error(result.error.errors[0].message);
    }
    const response = await api.put(`/knowledge/${itemId}`, data);
    if (response.status > 299) {
      throw new Error("Failed to update knowledge base");
    }

    toast({
      title: "Knowledge Base updated",
      description: "The knowledge base has been updated successfully",
    });

    return response.data;
  } catch (error) {
    console.error("Failed to update knowledge base", error);
    return null;
  }
}
